import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, postApi } from 'services/_api';

import { PATH_DETRAN_CRV, CHANNEL } from 'services/_path';

import { ReducerAction } from 'store/modules/types';

import { Types, ITXUTRequest } from './types';

import { consultarTXUTSuccess, consultarTXUTFailure } from './actions';

function* consultarTXUTRequest(request: ReducerAction) {
	const { payload }: { payload: ITXUTRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`resumo-veiculo/${CHANNEL}/pesquisa/taxas`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarTXUTSuccess(response));
	} else if (response.error) {
		yield put(consultarTXUTFailure(response));
	}
}

export default all([takeLatest(Types.TXUT_REQUEST, consultarTXUTRequest)]);
